/* eslint-disable jira/filename-case */
import React from 'react';
import { SidebarBoundary } from '@jira/navigation-apps__sidebar-common/src/async.tsx';
import {
	setPerformanceMarkLoadStart,
	setPerformanceMarkLoadEnd,
} from '@jira/navigation-apps__sidebar-common/src/utils/performance-marks/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { TeamDashboardSidebar as TeamDashboardSidebarType } from './ui/index.tsx';

export const LazyTeamDashboardSidebar: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof TeamDashboardSidebarType
>(
	() => {
		setPerformanceMarkLoadStart();
		return import(/* webpackChunkName: "async-sidebar-team-dashboard" */ './index.tsx').then(
			(bundle) => {
				setPerformanceMarkLoadEnd();
				return bundle;
			},
		);
	},
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

const TeamDashboardSidebar: {
	(): React.JSX.Element;
	displayName: string;
} = (): React.JSX.Element => (
	<SidebarBoundary id="eocTeamDashboard">
		<LazyTeamDashboardSidebar />
	</SidebarBoundary>
);

TeamDashboardSidebar.displayName = 'TeamDashboardSidebar';

export default TeamDashboardSidebar;
